<template>   
    <div class="modal fade" :id="modal" tabindex="-1" aria-hidden="true" >  
        <div class="modal-dialog" style="max-width:1700px;">  
            <div class="modal-content"  style="min-height: 550px;">  
                <div class="modal-header"> 
					<h2>{{titulo}}</h2> 
					<div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" >
						<span class="svg-icon svg-icon-1">
							<inline-svg src="media/icons/duotone/Navigation/Close.svg" />
						</span>
					</div> 
				</div> 
				<div class="modal-body scroll-y m-5 "  >
                    <div class="row g-6 g-xl-12"   >   
                        <div class="form-group">  
                            <label for="datapublicacao" class="form-label">Arquivo</label>
                            <input type="file" id="arquivo" ref="arquivoReferencia" name="arquivo" class="form-control" accept="application/pdf" v-on:change="handleFileUpload()">  
                        </div>
                    </div>  
                    <br>
				</div>  
                <div class="modal-footer"  > 
                    <BotaoSalvar  @click="salvar" :processando="processando" ></BotaoSalvar>   
				</div> 
			</div> 
		</div> 
	</div>  
</template>

<script lang="ts">  
 
    import { PerfilConfig } from "@/core/config/PerfisConfig";
    import   SiteUtils   from '@/assets/ts/aplicacao/site'; 
    import QtsPdfService from   "@/service/v1/sigap/QtsPdfService"   
	import $ from "jquery"   
    import { ref } from 'vue';
    import { Options, Vue  } from "vue-class-component";  
    import {  Prop   } from 'vue-property-decorator';   
    import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
	  
    @Options({
        name: "QtsCadastro",
        components: {  BotaoSalvar },  
        emits: [  'qts-alterado-arquivo'],  
    }) 
    export default class QtsCadastro extends Vue {
        
        @Prop( ) readonly modelo!: any  
        @Prop( ) readonly modal!: any  
        @Prop( ) readonly perfis!: any  


        public service = new QtsPdfService();  
        private arquivoReferencia = ref<FileList | null>(null);
        public arquivo: any = '';
        public turmaId: any = null;
        public titulo = 'Cadastro';
        public processando = false;  
         
        handleFileUpload() {  
            this.arquivo =  ( this.arquivoReferencia as any ).files![0]; 
        }
  
        async created()  {  
            this.titulo = 'Atualizar o arquivo do Qts'; 
            this.turmaId = this.$route.params.id;
        }
   
        get hasPermissao(   ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE] ,  this.perfis); 
        }
    
        public sucesso(){  
            this.$emit("qts-alterado-arquivo", null);     
            $("[data-bs-dismiss='modal']").trigger({ type: "click" });
        }
 

        public salvar() {  
            this.processando = true;
            const dados = new FormData(); 
            if (this.arquivo ) {
                dados.append('File', this.arquivo);  
            } 
            this.service.atualizarArquivo( this.modelo.id,  dados )
            .then(response => {
                this.sucesso(); 
                SiteUtils.toastSucesso('Alteração realizada com sucesso! ' ,  response.message  );
                this.processando = false; 
            })
            .catch(error => {  
                this.processando = false; 
                console.log(error);
            })
            .finally( () => {
                this.processando = false;
            });    
        } 
 
 
    } 
</script>
 